module.exports = __webpack_public_path__ + "static/media/Pyke_0.e2e62970.png";